import {
  all,
  complement,
  converge,
  filter,
  flip,
  includes,
  length,
  lt,
  path,
  pipe,
  prop,
} from 'ramda'

export const selectGameState = path(['location', 'query'])

const isComplete = converge(all, [
  pipe(prop('tries'), flip(includes)),
  prop('word'),
])

export const selectIsComplete = pipe(selectGameState, isComplete)

const incorrectTries = converge(pipe(filter, length), [
  pipe(prop('word'), flip(includes), complement),
  prop('tries'),
])

export const selectIncorrectTries = pipe(selectGameState, incorrectTries)

const isLost = pipe(incorrectTries, lt(9))

export const selectIsLost = pipe(selectGameState, isLost)